import React from "react";
 

// Auth Imports
import SignIn from "views/auth/SignIn";
import SignUp from "views/auth/SignUp";

// Icon Imports
import {
  MdLocalPhone,
  MdVerifiedUser,
  MdLock,
} from "react-icons/md";
import Verify from "views/auth/Verify";
 import Landing from "views/auth/Landing";
 import Gallery from "views/auth/Gallery";
 import Editprofile from "views/auth/Editprofile";
import Feedback from "views/auth/Feedback";
import Event from "views/auth/Event";
import UserProfile from "views/auth/UserProfile";
import QRScanner from "views/auth/QRReader";
import Qrcode from "views/auth/Qrcode";
import Notifications from "views/auth/Notification";
import EventScan from "views/auth/Eventscan";
import Home from "views/auth/Home";
import AddEventForm from "views/auth/AddEventForm";
import EventTable from "views/auth/EventTable";
import SavedProfiles from "views/auth/SavedProfiles";

const routes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "default",
    icon: <MdLock className="h-6 w-6" />,
    component: <Landing />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Phone Number",
    layout: "/auth",
    path: "sign-up",
    icon: <MdLocalPhone className="h-6 w-6" />,
    component: <SignUp />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "regular-sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "QR SCAN",
    layout: "/auth",
    path: "qr-scanner",
    icon: <MdLocalPhone className="h-6 w-6" />,
    component: <QRScanner />,
  },
 
  {
    name: "QR Search",
    layout: "/auth",
    path: "search-event",
    icon: <MdLocalPhone className="h-6 w-6" />,
    component: <Qrcode />,
  },
 
  {
    name: "Sxene",
    layout: "/auth",
    path: "landing",
    icon: <MdVerifiedUser className="h-6 w-6" />,
    component: <Landing />,
  },
 
  {
    name: "AddEvents",
    layout: "/auth",
    path: "add-event",
    icon: <MdLock className="h-6 w-6" />,
    component: <AddEventForm />,
  },
 
  {
    name: "Edit Profile",
    layout: "/auth",
    path: "edit-profile",
    icon: <MdLock className="h-6 w-6" />,
    component: <Editprofile />,
  },
   {
    name: "Saved Profiles",
    layout: "/auth",
    path: "saved-profiles",
    icon: <MdLock className="h-6 w-6" />,
    component: <SavedProfiles />,
  },
  {
    name: "Edit Profile",
    layout: "/auth",
    path: "events",
    icon: <MdLock className="h-6 w-6" />,
    component: <Event />,
  },
  {
    name: "Profile",
    layout: "/auth",
    path: "user-profile",
    icon: <MdLock className="h-6 w-6" />,
    component: <UserProfile />,
  },
  {
    name: "Notifications",
    layout: "/auth",
    path: "notifications",
    icon: <MdLock className="h-6 w-6" />,
    component: <Notifications />,
  },
  {
    name: "EventScan",
    layout: "/auth",
    path: "eventscan",
    icon: <MdLock className="h-6 w-6" />,
    component: <EventScan />,
  },
  {
    name: "Home",
    layout: "/auth",
    path: "home",
    icon: <MdLock className="h-6 w-6" />,
    component: <Home />,
  },
  {
    name: "Feedback",
    layout: "/auth",
    path: "send-feedback",
    icon: <MdLock className="h-6 w-6" />,
    component: <Feedback />,
  },

  {
    name: "Gallery",
    layout: "/auth",
    path: "event-photos",
    icon: <MdLock className="h-6 w-6" />,
    component: <Gallery />,
  },
 
  {
    name: "MyEvents",
    layout: "/auth",
    path: "MyEvents",
    icon: <MdLock className="h-6 w-6" />,
    component: <EventTable />,
  },
 
];
export default routes;
